export const isWarrantyTimeline = (item = {}) =>
  item.return_type === "warranty_claim" ||
  (Array.isArray(item.timeline) ? item.timeline : []).some((step) => /^W/.test(step.code || ""));

export const warrantyTimelineSteps = (item = {}) =>
  (Array.isArray(item.timeline) ? item.timeline : [])
    .filter((step) => step.customer_visible !== false)
    .map((step) => ({
      ...step,
      finalCompleted:
        (step.code === "W6" || step.code === "T2") &&
        Boolean(step.completed || step.current),
    }));

export const progressedShippingDescription = (request = {}) => {
  const status = String(request.status || "").toLowerCase().replaceAll("_", " ");
  if (["return received", "return delivered", "delivered"].includes(status)) {
    return "Your item has been received. Follow the item timeline below for the latest updates.";
  }
  const items = Array.isArray(request.line_items) ? request.line_items : [];
  if (items.length && items.every((item) =>
    item.return_shipment_awb && String(item.return_shipment_awb).toLowerCase() !== "customer"
  )) {
    return "Shipment tracking is available. Follow the item timeline below for the latest updates.";
  }
  return null;
};
